module.exports = __webpack_public_path__ + "img/denisov.6fadaa79.png";